import type { ComponentProps } from 'react';

interface Props extends ComponentProps<'svg'> {
  className?: string;
  width?: number;
  height?: number;
}

const HubertLogoName = ({ width = 240, height = 40, ...props }: Props) => {
  return (
    <svg
      {...props}
      width={width} //width="240"
      height={height} //height="40"
      viewBox="0 0 240 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.3456 0.613281H4.51916C2.03362 0.613281 0 2.6469 0 5.13244V34.9589C0 37.4444 2.03362 39.478 4.51916 39.478H34.3456C36.8311 39.478 38.8647 37.4444 38.8647 34.9589V5.13244C38.8647 2.61462 36.8311 0.613281 34.3456 0.613281ZM19.4324 37.8963C9.55479 37.8963 1.54943 29.891 1.54943 20.0134C1.54943 10.1358 9.55479 2.13043 19.4324 2.13043C29.31 2.13043 37.3153 10.1358 37.3153 20.0134C37.3153 29.891 29.31 37.8963 19.4324 37.8963Z"
        fill="white"
      />
      <path
        d="M58.2969 37.8963C68.1734 37.8963 76.1798 29.8898 76.1798 20.0133C76.1798 10.1368 68.1734 2.13037 58.2969 2.13037C48.4204 2.13037 40.4139 10.1368 40.4139 20.0133C40.4139 29.8898 48.4204 37.8963 58.2969 37.8963Z"
        fill="white"
      />
      <path
        d="M115.594 0.613281V39.4457H110.881V21.5305H90.2868V39.4457H85.574V0.613281H90.2868V17.2696H110.881V0.613281H115.594Z"
        fill="white"
      />
      <path
        d="M144.452 39.4457H140.03V34.055C138.577 37.9286 135.156 39.8976 130.83 39.8976C124.503 39.8976 120.404 35.4108 120.404 28.5675V11.4592H124.858V27.825C124.858 32.6024 127.634 35.8304 131.863 35.8304C136.705 35.8304 140.062 31.9891 140.062 26.5661V11.4592H144.517V39.4457H144.452Z"
        fill="white"
      />
      <path
        d="M153.135 34.8298V39.4458H148.681V0H153.135V16.043C154.846 13.041 158.462 11.0397 162.4 11.0397C171.115 11.0397 175.893 17.3019 175.893 25.4687C175.893 33.6354 171.115 39.8977 162.4 39.8977C158.526 39.8977 154.846 37.8964 153.135 34.8298ZM171.341 25.4687C171.341 19.1419 167.694 15.0423 162.012 15.0423C156.396 15.0423 152.748 19.1419 152.748 25.4687C152.748 31.7955 156.396 35.895 162.012 35.895C167.661 35.895 171.341 31.7955 171.341 25.4687Z"
        fill="white"
      />
      <path
        d="M204.977 30.4719C204.04 36.1854 199.102 39.8976 192.162 39.8976C183.898 39.8976 178.346 33.2803 178.346 25.3072C178.346 17.1081 183.446 11.0396 191.677 11.0396C199.844 11.0396 204.718 16.6885 204.718 24.1451C204.718 24.7584 204.654 25.6945 204.622 26.0819H182.768C183.091 31.86 186.932 35.9595 192.194 35.9595C196.745 35.9595 199.618 33.9581 200.522 30.4719H204.977ZM182.962 22.5311H200.167C199.844 17.8183 196.681 14.8163 191.677 14.8163C186.932 14.8163 183.769 17.5923 182.962 22.5311Z"
        fill="white"
      />
      <path
        d="M220.794 15.4297C215.145 15.4297 213.531 20.5299 213.531 27.1472V39.4781H209.076V11.4916H213.531V17.1405C214.693 13.2992 217.017 11.4916 221.149 11.4916H224.409V15.4297H220.794ZM231.414 2.5501V11.4916H240V15.4297H231.414V30.5689C231.414 33.6677 233.189 35.5077 235.9 35.5077H240V39.4458H235.739C230.413 39.4458 226.959 36.121 226.959 30.6657V2.51782H231.414V2.5501Z"
        fill="white"
      />
    </svg>
  );
};

export default HubertLogoName;
